/**
 * worldTime — THE WORLD'S DATE AND TIME, as every screen reads it (the viewer's src/worldClock.ts + src/worldCalendar.ts, and the
 * shard's daemon/clock.mjs — the same arithmetic, kept in step): 8 world hours a real hour since 11-02 (a day in 3 real hours — the
 * Chair: the reporter's show is his whole day; it was 15 until WORLD_SWITCH_MS), the PHASE putting the world's 06:30 on every third hour
 * of UTC; a month 30 world days, a year 12 months; Year 1 began on the world day that held 22 October 2026, 00:00 UTC, a Monday — the
 * days the clock counted at 15 before the switch are kept, so the date carried on. Running time — read from the real clock, never predicted.
 * The console's panels (the ring, the trace, the tree) read the hour and the day HERE — nowhere else a rate.
 */
export const WORLD_RATE = 8, WORLD_PHASE_H = 6.5, WORLD_SWITCH_MS = Date.parse('2026-11-03T03:00:00Z')
const MONTH_DAYS = 30, YEAR_DAYS = 360
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
/** game hours since the world began (continuous) at real time `ms` */
export const worldHours = (ms: number = Date.now()): number => (ms / 3_600_000) * WORLD_RATE + WORLD_PHASE_H
/** the hour of the day (0 ≤ h < 24) */
export const worldHour = (ms: number = Date.now()): number => ((worldHours(ms) % 24) + 24) % 24
/** the day's number (whole game days since the world began) */
export const worldDay = (ms: number = Date.now()): number => Math.floor(worldHours(ms) / 24)
/** "07:45" */
export const hhmm = (h: number): string => `${String(Math.floor(h)).padStart(2, '0')}:${String(Math.floor((h % 1) * 60)).padStart(2, '0')}`
const daysAt15 = (ms: number) => Math.floor(((ms / 3_600_000) * 15) / 24)
const EPOCH_DAY = worldDay(WORLD_SWITCH_MS) - (daysAt15(WORLD_SWITCH_MS) - daysAt15(Date.parse('2026-10-22T00:00:00Z')))
/** "Mon 29 Jan · Year 1 · 18:00" at real moment `ms` */
export function worldDateText(ms: number = Date.now()): string {
  const h = worldHours(ms), d = Math.floor(h / 24), hod = h - d * 24, n = d - EPOCH_DAY
  const y = Math.floor(n / YEAR_DAYS), doy = n - y * YEAR_DAYS, m = Math.floor(doy / MONTH_DAYS), wd = ((n % 7) + 7) % 7
  return `${WEEKDAYS[wd]} ${doy - m * MONTH_DAYS + 1} ${MONTHS[m]} · Year ${y + 1} · ${hhmm(hod)}`
}
